import React, { lazy, Suspense } from 'react';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

const TemplateGalleryContent = lazy(() =>
  import(
    /* webpackChunkName: "templates-container" */ './TemplateGalleryContent'
  ),
);

export const LazyTemplateGalleryContent: React.FunctionComponent<{
  category?: string;
  isInAppGallery?: boolean;
  shortLink?: string;
}> = ({ category, isInAppGallery, shortLink }) => {
  return (
    <Suspense fallback={null}>
      <ComponentWrapper>
        <TemplateGalleryContent
          category={category}
          shortLink={shortLink}
          isInAppGallery={isInAppGallery}
        />
      </ComponentWrapper>
    </Suspense>
  );
};
